<div class="not_ti">
  <!-- <img src="/assets/images/page_icon/notification.png" />
  <span><div class="not_badge">34</div></span>  -->
</div>
